var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-100" }, [
    _c(
      "a",
      {
        staticClass: "block__absolute block__absolute--auto",
        on: {
          click: function ($event) {
            _vm.step == 2 ? (_vm.step = 1) : _vm.$emit("backClickedFromForgot")
          },
        },
      },
      [
        _c("img", {
          staticClass: "icon icon-xs",
          attrs: {
            src: require("@/assets/img/icons/svgs/solid/arrowLeft.svg"),
          },
        }),
      ]
    ),
    _c("div", { staticClass: "card-header bg-transparent pb-4 border-0" }, [
      _c(
        "div",
        {
          staticClass: "logo-head mx-auto",
          staticStyle: { "maring-top": "30px", "margin-bottom": "80px" },
        },
        [_c("logo")],
        1
      ),
      _c("div", [
        _vm.step == 1
          ? _c(
              "form",
              { attrs: { role: "form" } },
              [
                _c("base-input", {
                  staticClass: "mb-3",
                  attrs: {
                    alternative: "",
                    "prepend-icon": "ni ni-email-83",
                    placeholder: "Enter email address",
                  },
                  model: {
                    value: _vm.email,
                    callback: function ($$v) {
                      _vm.email = $$v
                    },
                    expression: "email",
                  },
                }),
                _vm.$v.email.$error
                  ? _c("div", { staticClass: "error field" }, [
                      _vm._v("Valid email is required"),
                    ])
                  : _vm._e(),
                _vm.serverError.email
                  ? _c("div", { staticClass: "error field" }, [
                      _vm._v(_vm._s(_vm.serverError.email)),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "my-4 btn-block",
                        attrs: { type: "primary" },
                        on: { click: _vm.onResetClick },
                      },
                      [_vm._v("Reset Now")]
                    ),
                  ],
                  1
                ),
                _c(
                  "p",
                  {
                    staticClass: "text-center text-muted mb-5",
                    staticStyle: { "margin-top": "-15px" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("iAmNewClicked")
                          },
                        },
                      },
                      [_c("small", [_vm._v("Sign Up")])]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.step == 2
          ? _c(
              "form",
              { attrs: { role: "form" } },
              [
                _c("div", { staticClass: "mb-1" }, [
                  _vm._v(
                    "You've requested to reset your password. Please check your email for the Reset Code and complete the form below."
                  ),
                ]),
                _c("br"),
                _c("base-input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  staticClass: "mb-3",
                  attrs: {
                    alternative: "",
                    "prepend-icon": "ni ni-email-83",
                    placeholder: "Email",
                  },
                  model: {
                    value: _vm.email,
                    callback: function ($$v) {
                      _vm.email = $$v
                    },
                    expression: "email",
                  },
                }),
                _vm.$v.email.$error
                  ? _c("div", { staticClass: "error field" }, [
                      _vm._v("Valid email is required."),
                    ])
                  : _vm._e(),
                _vm.serverError.email
                  ? _c("div", { staticClass: "error field" }, [
                      _vm._v(_vm._s(_vm.serverError.email)),
                    ])
                  : _vm._e(),
                _c("base-input", {
                  staticClass: "mb-3",
                  attrs: {
                    alternative: "",
                    "prepend-icon": "ni ni-email-83",
                    placeholder: "Reset Code",
                  },
                  model: {
                    value: _vm.code,
                    callback: function ($$v) {
                      _vm.code = $$v
                    },
                    expression: "code",
                  },
                }),
                _vm.$v.code.$error
                  ? _c("div", { staticClass: "error field" }, [
                      _vm._v("Valid reset code is required."),
                    ])
                  : _vm._e(),
                _vm.serverError.code
                  ? _c(
                      "div",
                      { staticClass: "error field" },
                      _vm._l(_vm.serverError.code, function (item, index) {
                        return _c("span", { key: index }, [
                          _vm._v(
                            "\n            " + _vm._s(item) + "\n          "
                          ),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _c("base-input", {
                  staticClass: "mb-3",
                  attrs: {
                    alternative: "",
                    "prepend-icon": "ni ni-lock-circle-open",
                    type: "password",
                    placeholder: "New Password",
                  },
                  model: {
                    value: _vm.password,
                    callback: function ($$v) {
                      _vm.password = $$v
                    },
                    expression: "password",
                  },
                }),
                _vm.$v.password.$error
                  ? _c("div", { staticClass: "error field" }, [
                      _vm._v(
                        "Passwords should be a minimum of 8 Characters, with at least one uppercase, one lowercase and one number or special character."
                      ),
                    ])
                  : _vm._e(),
                _c("base-input", {
                  staticClass: "mb-3",
                  attrs: {
                    alternative: "",
                    "prepend-icon": "ni ni-lock-circle-open",
                    type: "password",
                    placeholder: "Confirm New Password",
                  },
                  model: {
                    value: _vm.confirm,
                    callback: function ($$v) {
                      _vm.confirm = $$v
                    },
                    expression: "confirm",
                  },
                }),
                _vm.$v.confirm.$required == false
                  ? _c("div", { staticClass: "error field" }, [
                      _vm._v("Confirm password is required."),
                    ])
                  : _vm._e(),
                _vm.$v.confirm.sameAsPassword == false
                  ? _c("div", { staticClass: "error field" }, [
                      _vm._v("Confirm should match with password."),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "my-4 btn-block",
                        attrs: { type: "primary" },
                        on: { click: _vm.onResetCompleteClicked },
                      },
                      [_vm._v("Change Password")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }